import React from 'react';
import { Link } from './styled/Text';

type Props = {
  children: React.ReactNode;
  onClick?: () => void;
};

const EmailLink = ({ children, onClick }: Props) => (
  <Link href={`mailto:${children}`} onClick={onClick}>
    {children}
  </Link>
);
EmailLink.defaultProps = {
  onClick: undefined,
};

export default EmailLink;
